import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonEditLink} from 'mui-tiptap';

const StyledEditorMenuButtonEditLink = styled(MenuButtonEditLink)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonEditLink.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonEditLink;
